import {
  Component, Input, Output, EventEmitter,
  OnInit, OnDestroy, ChangeDetectorRef
} from '@angular/core';
import { Banner } from 'src/app/persistences/banner';

@Component({
  standalone: false,
  selector: 'app-banner-carrossel',
  templateUrl: './banner-carrossel.component.html',
  styleUrls: ['./banner-carrossel.component.css']
})
export class BannerCarrosselComponent implements OnInit, OnDestroy {
  @Input() banners: Banner[] = [];
  @Input() intervaloMs: number = 5000;
  @Output() bannerClicado = new EventEmitter<string>();

  indiceAtual = 0;
  private intervalId: any;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    if (this.banners.length > 1) {
      this.iniciarIntervalo();
    }
  }

  ngOnDestroy(): void {
    this.pararIntervalo();
  }

  proximoBanner(): void {
    this.indiceAtual = (this.indiceAtual + 1) % this.banners.length;
  }

  proximoBannerManual(): void {
    this.proximoBanner();
    this.reiniciarIntervalo();
  }

  bannerAnterior(): void {
    this.indiceAtual =
      (this.indiceAtual - 1 + this.banners.length) % this.banners.length;
    this.reiniciarIntervalo();
  }

  irParaBanner(index: number): void {
    this.indiceAtual = index;
    this.reiniciarIntervalo();
  }

  onClickBanner(banner: Banner): void {
    if (banner.cdAcesso) {
      this.bannerClicado.emit(banner.cdAcesso);
    }
  }

  private iniciarIntervalo(): void {
    this.intervalId = setInterval(() => {
      this.proximoBanner();
      this.cdr.detectChanges();
    }, this.intervaloMs);
  }

  private pararIntervalo(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  private reiniciarIntervalo(): void {
    this.pararIntervalo();
    if (this.banners.length > 1) {
      this.iniciarIntervalo();
    }
  }
}
